import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateCostMaster } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateCostMaster() {
  return useMutation({
    mutationFn: async ({ item, costmasterId }) => {
      const payload = buildPayload(item);
      const response = await updateCostMaster({ item: payload, costmasterId });
      return response;
    },
    onSuccess: () => {
      toast.success("Cost Master Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
